import { listado } from "./listado";
import { backend } from "./backend";

export function crear() {
  return {
    id: null,
    razonSocial: "",
    nombreComercial: "",
    identificadorFiscal: "",
    ciudad: "",
    provincia: "",
    codigoPostal: "",
    direccion: "",
    email: "",
    telefono: "",
    representanteLegal: "",
    identificadorRepresentanteLegal: "",
    estado: null,
    tarifaId: null,
    cartaBienvenida: "",
  };
}

export function listar(params) {
  return listado("unidadNegocio/listar", params);
}

export function autocompletar(params) {
  return backend.get("unidadNegocio/autocompletar", { params }).then((r) => r.data);
}

export function cargar(id) {
  return backend.get("unidadNegocio/cargar&id=" + id).then((response) => {
    var data = response.data;

    data.unidadNegocio.estado = Boolean(data.unidadNegocio.estado);
    return data;
  });
}

export function insertar(unidadNegocio) {
  return backend.post("unidadNegocio/insertar", {
    unidadNegocio: unidadNegocio.unidadNegocio,
    paises: unidadNegocio.paises,
  });
}

export function actualizar(unidadNegocio) {
  return backend.post("unidadNegocio/actualizar", {
    unidadNegocio: unidadNegocio.unidadNegocio,
    paises: unidadNegocio.paises,
  });
}

export function eliminar(id) {
  return backend.post("unidadNegocio/eliminar", { id });
}

export function obtenerPaises(id) {
  return backend.get("paises/listar&unidadNegocioId=" + id).then((r) => r.data);
}

export function cargarTarifa(id) {
  return backend.get("unidadNegocio/cargarTarifa&id=" + id).then((r) => r.data);
}
